<script setup lang="ts">
import bg1 from '~/assets/images/user/vip/vip-card-bg1.png'
import bg2 from '~/assets/images/user/vip/vip-card-bg2.png'
import bg3 from '~/assets/images/user/vip/vip-card-bg3.png'

const props = defineProps<{
  data: any
  payType: number
}>()
const style = computed(() => {
  const bgImages: Record<number, any> = {
    1: bg1,
    2: bg2,
    3: bg3,
  }
  return {
    background: `url(${bgImages[props.data.resource]}) #fff center top/100% auto no-repeat`,
  }
})
const curPrivilege = computed(() => {
  return props.data?.privileges?.find((item: Api.User.Privilege) => item.month === props.payType)
})
const { open } = useVipModal()
// const { locale } = useI18n()
const { isSubAccount } = useLogin()
</script>

<template>
  <div box-border h-610 w-525 flex flex-col items-center gap-30 rd-16 bg-white px-50 py-30 :style="style">
    <div flex flex-col items-center gap-12>
      <UserVipSign :data="data" />
      <p class="my-0 text-12 text-[--color-text-2]">
        {{ $t(data.dec) }}
      </p>
    </div>
    <div v-if="data.resource === 3" text-24 font-600 class="my-22 text-[--color-text-1]">
      {{ $t('vip.免费体验') }}
    </div>
    <div v-else class="flex items-end gap-4">
      <span class="text-64 text-[--color-text-1] font-dinpro600"><span text-stroke-1.5>￥</span><span ml--10>{{ curPrivilege?.realPrice }}</span></span>
      <div relative box-border h-full flex items-end gap-4 pb-10>
        <span class="text-16 text-[--color-text-1] font-600">/{{ payType === 1 ? $t('月') : $t('年') }}</span>
        <span class="text-18 text-[--color-text-3] font-600 lh-18 line-through">￥{{ curPrivilege?.originalPrice }}&nbsp;</span>
        <!-- <span v-if="curPrivilege?.discount < 10" absolute left-4 top-11 w-fit rd-11 rd-bl-0 px-14 color-white lh-22 ellipsis :class="{ 'text-11': locale === 'en' }" style="background: linear-gradient(95deg, #EC1DBC 1.69%, #A804C1 94.09%);">{{ $t('vip.eclusive', [locale === 'en' ? 100 - curPrivilege?.discount * 10 : curPrivilege?.discount]) }}</span> -->
      </div>
    </div>
    <UserVipBtn :disabled="isSubAccount" class="flex-shrink-0 !h-64 !text-22" :data="data" :payType="payType" @click="open(payType, data.resource)">
      <span v-if="isSubAccount" class="text-12">{{ $t('暂无法购买') }}</span>
    </UserVipBtn>
    <div mt-20>
      <div v-for="item in data?.list" :key="item.label" mb-11 flex items-center gap-8 lh-24 class="w-full text-[--color-text-2] ellipsis">
        <g-svg :color="item.limit ? data.resource === 1 ? '#5E42AF' : '#FBA64D' : '#00CA6A'" name="vip/star" />
        {{ $t(item.label) }}
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>

</style>
